import { DateRangeOption } from '../schema/DateRangeOption';

/**
 * Typescript enums store a string and a number as a key
 * we filter out the string keys and return the number
 * keys as DateRangeOptions
 */
export function getAllDateRangeOptions() {
    return Object.keys(DateRangeOption)
        .filter(key => isNaN(Number(DateRangeOption[key])))
        .map(n => Number(n) as DateRangeOption);
}
